import { useParams } from 'react-router-dom';

export const useRequiredParam = (param: string) => {
  const params = useParams();
  if (!params[param]) throw new Error(`Missing required parameter ${param}`);
  return params[param]!;
};
